export default __webpack_public_path__ + "static/media/dashboard.a42ad40e.svg";